import { buildWabunkaReservationQuestionAnswerListViewModel } from '@/models/wabunka/wabunkaReservationQuestionAnswer';
import type { WabunkaReservationQuestionAnswerViewModel, WabunkaReservationQuestionViewModel } from '@/models/wabunka/wabunkaReservationQuestionAnswer';
import { WABUNKA_RESERVATION_QUESTION_PREFERRED_DATE_TIME_ID } from '@/wabunka-src/constants/wabunkaReservationQuestionPrefferedDateTime';

/**
 * 予約フォームに出す質問一覧を組む。生成経路を 1 本にするための関数。
 *
 * 第一希望日時の質問はカレンダーが役目を引き継いだため出さない（旧マスタに紐づいたまま残っている）。
 * 引き継ぎは**質問 ID で引く**。index で引くと、経路ごとに質問の集合が違った瞬間に回答が別の質問へ付く。
 */
export const buildReservationQuestionAnswers = (
  reservationQuestions: WabunkaReservationQuestionViewModel[],
  previousAnswers: WabunkaReservationQuestionAnswerViewModel[] = [],
  restoredAnswers: Map<string, string> = new Map(),
): WabunkaReservationQuestionAnswerViewModel[] => {
  const previousAnswerById = new Map(previousAnswers.map((questionAnswer) => [questionAnswer.id, questionAnswer.answer]));

  return buildWabunkaReservationQuestionAnswerListViewModel(reservationQuestions)
    .filter((questionAnswer) => questionAnswer.id !== WABUNKA_RESERVATION_QUESTION_PREFERRED_DATE_TIME_ID)
    .map((questionAnswer) => ({
      ...questionAnswer,
      answer: restoredAnswers.get(questionAnswer.id) || previousAnswerById.get(questionAnswer.id) || questionAnswer.answer,
    }));
};
